import React from 'react'

function Logout ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 21.33 23.996'>
      <path d='M202.668,0h1.066V11.2h-1.066Zm0,0' transform='translate(-192.536)' />
      <path d='M10.665,82.518A10.668,10.668,0,0,1,7.705,61.6L8,62.628a9.6,9.6,0,1,0,5.326,0l.293-1.026a10.667,10.667,0,0,1-2.953,20.917Zm0,0' transform='translate(0 -58.522)' />
    </svg>
  )
}

Logout.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Logout
